import { useState, useEffect, PropsWithChildren, useCallback } from "react";

type DataListProps = {
  fetchData: (pageNo: number) => void;
  hasMore: boolean;
};

export const InfiniteScroll = ({
  fetchData,
  hasMore,
  children,
}: PropsWithChildren<DataListProps>) => {
  const [page, setPage] = useState(1);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, []);

  const handleScroll = useCallback((event: any) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight;
    if (isNearBottom) {
      let timeoutId: NodeJS.Timeout;
      if (hasMore) {
        timeoutId = setTimeout(() => {
          clearTimeout(timeoutId);
          fetchData(page);
          setPage(page + 1);
        }, 500);
      }
    }
  }, []);

  return <>{children}</>;
};
